var _regeneratorRuntime = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _classCallCheck = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/helpers/createClass.js");

/*
  This adapter is designed to poll the /about JSON RPC endpoint for IPFS Service
  Providers that leverage ipfs-coord. This allows other consumers of the
  ipfs-coord library to measure the latency between themselves and potential
  Circuit Relays.

  Using these metrics, IPFS nodes can prioritize the Circuit Relays with the
  lowest latency. At scale, this allows the entire IPFS subnet to adapt to
  changing network conditions.
*/
var AboutAdapter = /*#__PURE__*/function () {
  "use strict";

  function AboutAdapter() {
    var localConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, AboutAdapter);

    // Time to wait for a reponse from the RPC.
    this.waitPeriod = 10000; // Used to pass asynchronous data when pubsub data is received.

    this.incomingData = false;
  } // Query the /about JSON RPC endpoint for a subnet peer.
  // This function will return true on success or false on failure or timeout
  // of 10 seconds.
  // This function is used to measure the time for a response from the peer.


  _createClass(AboutAdapter, [{
    key: "queryAbout",
    value: function () {
      var _queryAbout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(ipfsId, thisNode) {
        var idNum, id, cmdStr, result;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                // console.log(`Querying Relay ${ipfsId}`)
                // console.log('thisNode: ', thisNode)
                // Generate the JSON RPC command
                idNum = Math.floor(Math.random() * 10000).toString();
                id = "metrics".concat(idNum);
                cmdStr = "{\"jsonrpc\":\"2.0\",\"id\":\"".concat(id, "\",\"method\":\"about\"}"); // console.log(`cmdStr: ${cmdStr}`)
                // console.log(`Sending JSON RPC /about command to ${ipfsId}`)

                _context.next = 6;
                return this.sendRPC(ipfsId, cmdStr, id, thisNode);

              case 6:
                result = _context.sent;
                return _context.abrupt("return", result);

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](0);
                console.error('Error in queryAbout()'); // Do not throw an error.

                return _context.abrupt("return", false);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 10]]);
      }));

      function queryAbout(_x, _x2) {
        return _queryAbout.apply(this, arguments);
      }

      return queryAbout;
    }() // This function is called by pubsub.captureMetrics() when a response is
    // recieved to an /about request. The data is used by sendRPC().

  }, {
    key: "relayMetricsReceived",
    value: function relayMetricsReceived(inData) {
      this.incomingData = inData;
    } // Send the RPC command to the service, wait a period of time for a response.
    // Timeout if a response is not recieved.

  }, {
    key: "sendRPC",
    value: function () {
      var _sendRPC = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(ipfsId, cmdStr, id, thisNode) {
        var retData, start, now, timeDiff, jsonData, respId;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                retData = this.incomingData; // Send the RPC command to the server/service.

                _context2.next = 4;
                return thisNode.useCases.peer.sendPrivateMessage(ipfsId, cmdStr, thisNode);

              case 4:
                // Used for calculating the timeout.
                start = new Date();
                now = start;
                timeDiff = 0; // Wait for the response from the server. Exit once the response is
                // recieved, or a timeout occurs.

              case 7:
                _context2.next = 9;
                return thisNode.useCases.peer.adapters.bch.bchjs.Util.sleep(250);

              case 9:
                now = new Date();
                timeDiff = now.getTime() - start.getTime(); // console.log('timeDiff: ', timeDiff)

                retData = this.incomingData; // If data came in on the event emitter, analize it.

                if (!retData) {
                  _context2.next = 18;
                  break;
                }

                // console.log('retData: ', retData)
                jsonData = JSON.parse(retData);
                respId = jsonData.id; // If the JSON RPC ID matches, then it's the response thisNode was
                // waiting for.

                if (!(respId === id)) {
                  _context2.next = 18;
                  break;
                }

                // responseRecieved = true
                // this.eventEmitter.removeListener('relayMetrics', cb)
                retData = false;
                return _context2.abrupt("return", true);

              case 18:
                if ( // Exit once the RPC data comes back, or if a period of time passes.
                timeDiff < this.waitPeriod) {
                  _context2.next = 7;
                  break;
                }

              case 19:
                return _context2.abrupt("return", false);

              case 22:
                _context2.prev = 22;
                _context2.t0 = _context2["catch"](0);
                console.error('Error in sendRPC'); // this.eventEmitter.removeListener('relayMetrics', cb)

                throw _context2.t0;

              case 26:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 22]]);
      }));

      function sendRPC(_x3, _x4, _x5, _x6) {
        return _sendRPC.apply(this, arguments);
      }

      return sendRPC;
    }()
  }]);

  return AboutAdapter;
}();

module.exports = AboutAdapter;